import CourseWrapper from './CourseWrapper';

export default CourseWrapper;
